import { render, staticRenderFns } from "./EverythingBookmarks.vue?vue&type=template&id=44dcb05f&scoped=true&"
import script from "./EverythingBookmarks.vue?vue&type=script&lang=js&"
export * from "./EverythingBookmarks.vue?vue&type=script&lang=js&"
import style0 from "./EverythingBookmarks.vue?vue&type=style&index=0&id=44dcb05f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dcb05f",
  null
  
)

export default component.exports